<template>
  <div>
    <Header />

    <div class="py-3">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-0">
        <div
          class="flex flex-col lg:flex-row justify-between items-center gap-8 rounded-3xl shadow-xl my-10 h-full"
        >
          <div
            class="lg:px-20 flex flex-col py-10 gap-6 justify-between h-full text-center lg:text-left px-6"
          >
            <h1 class="font-bold text-3xl lg:text-5xl prime" v-if="this.userInfo">
              Welcome <span v-if="this.userInfo.user.display_name">
                {{ this.userInfo.user.display_name }}
              </span>
              <span v-else>{{ this.userInfo.user.permission }}</span>
              <span
                class="text-[#105C8E] text-xl lg:text-3xl ml-2 lg:ml-5"
              ></span>
            </h1>

            <div class="max-w-sm text-center lg:text-left">
              <h2 class="font-bold text-2xl lg:text-4xl text-[#1a2b6d] mb-4 leading-tight">
                Your Growth Journey <br/>
                <span class="text-blues">Continues Here</span>
              </h2>
              <p class="content text-lg">
                Access your learning resources, complete your assigned trainings, and build new skills — all in one place.
              </p>
            </div>

            <form @submit.prevent="searchUserValue" class="w-full">
              <div
                class="flex flex-wrap items-center justify-center lg:justify-start gap-4"
              >
                <input
                  type="text"
                  v-model="search_title"
                  @input="searchUserValue"
                  placeholder="Search The Course"
                  class="rounded-full px-6 py-3 border w-full lg:w-auto"
                />
                <button
                  type="submit"
                  class="bg-primary py-3 rounded-2xl text-white px-6"
                >
                  Search
                </button>
              </div>
            </form>
          </div>

          <div class="flex justify-center lg:justify-end w-full lg:w-auto">
            <img
              src="@/assets/new/index.jpeg"
              alt=""
              class="w-full lg:w-auto h-auto rounded-r-3xl object-contain max-h-[400px]"
            />
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Mentor/Header.vue";
import Footer from "@/components/Footer.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Header,
    Footer,
  },
  computed: mapGetters(["userInfo"]),
};
</script>

<style></style>
